import { Box } from '@material-ui/core'
import React, { useContext } from 'react'
import buildStyles from './styles'
import AppContext from '../../context'
import HeaderInfo from '../../../components/header-info/HeaderInfo'
import { useNavigate } from 'react-router-dom'
import FailedIconCD from '../../../shared/icons/failed_icon_CD'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { MOBILE_WIDTH_HIGH } from '../../../constants/constants'
import { PaymentStatus } from '../../../api/types'

const FailedTransactionView = () => {
  const { state } = useContext(AppContext)
  const navigate = useNavigate()

  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH

  if (!state.locationDesignConfig) return null
  const styles = buildStyles({
    isMobile: isMobile,
    baseColors: state.locationDesignConfig.baseColors,
  })

  const getTitle = () => {
    switch (state.paymentInfo?.status) {
      case PaymentStatus.Aborted:
        return 'Transakcja odrzucona'
      case PaymentStatus.Failed:
        return 'Transakcja nieudana'
      default:
        return ''
    }
  }

  const getMessage = () => {
    switch (state.paymentInfo?.status) {
      case PaymentStatus.Aborted:
        return 'Upewnij się, że masz wystarczającą ilość środków na koncie by zrealizować darowiznę.'
      case PaymentStatus.Failed:
        return 'Upewnij się, że masz wystarczającą ilość środków na koncie by zrealizować darowiznę.'
      default:
        return ''
    }
  }

  return (
    <>
      {state.selectedGoal && state.selectedOrganization && (
        <HeaderInfo
          title={getTitle()}
          arrowedTitle={state.selectedGoal.title}
          orgName={state.selectedOrganization.name}
          altText={state.amount?.txt}
          addedSmallPadding={true}
        />
      )}
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        padding="10px"
        className={styles.container}
      >
        <div className={styles.failedIcon}>
          <FailedIconCD width="100%" height="100%" />
        </div>

        <div className={styles.bottomText}>{getMessage()}</div>

        <Box
          display="flex"
          width="100%"
          paddingTop="25px"
          justifyContent="center"
        >
          <div
            className={styles.endButton}
            onClick={() =>
              navigate(
                `/${state.locationConfig?.locationCode}/${state.selectedOrganization?.id}/${state.selectedGoal?.id}/kwota`
              )
            }
          >
            <div className={styles.endButtonSpan}>SPRÓBUJ PONOWNIE</div>
          </div>
        </Box>
      </Box>
    </>
  )
}

export default FailedTransactionView
